// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file chat/v3/chat_messages.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { MessageErrorData, MessageLimitData, MessagePingData, MessageWarningData } from "./chat_messages_system_pb";
import { file_chat_v3_chat_messages_system } from "./chat_messages_system_pb";
import type { RichText } from "./chat_rich_text_pb";
import { file_chat_v3_chat_rich_text } from "./chat_rich_text_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Icon } from "../../common/v3/icons_pb";
import { file_common_v3_icons } from "../../common/v3/icons_pb";
import type { Feature } from "../../entitlements/v3/features_pb";
import { file_entitlements_v3_features } from "../../entitlements/v3/features_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor, file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat_messages.proto.
 */
export const file_chat_v3_chat_messages: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chat_v3_chat_messages_system, file_chat_v3_chat_rich_text, file_common_v3_common, file_common_v3_icons, file_entitlements_v3_features, file_google_protobuf_descriptor, file_google_protobuf_timestamp, file_google_protobuf_duration]);

/**
 * @generated from message chat.v3.Message
 */
export type Message = Message$1<"chat.v3.Message"> & {
  /**
   * Event discriminator for the message. This is used to determine the type of
   * event being sent.
   *
   * @generated from field: chat.v3.Event event = 1;
   */
  event: Event;

  /**
   * ID of the message.
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * The index of the message in the conversation. Used to distinguish
   * contiguous messages as additional events are streamed.
   *
   * @generated from field: int32 index = 3;
   */
  index: number;

  /**
   * Unique identifier for the block (part).
   *
   * @generated from field: string block_id = 4;
   */
  blockId: string;

  /**
   * @generated from field: string operation_id = 5;
   */
  operationId: string;

  /**
   * The role of the message sender.
   *
   * @generated from field: chat.v3.Role role = 6;
   */
  role: Role;

  /**
   * Activity is an optional field that can be used to provide additional
   * data. This may be sent on a start message.
   *
   * @generated from field: optional string activity = 7;
   */
  activity?: string;

  /**
   * The number of tokens received from the model.
   *
   * @generated from field: uint64 ingress_tokens = 8;
   */
  ingressTokens: bigint;

  /**
   * The number of tokens sent to the model.
   *
   * @generated from field: uint64 egress_tokens = 9;
   */
  egressTokens: bigint;

  /**
   * The number of ingress bytes received for the operation, which may include
   * source materials or other data not provided by a model.
   *
   * @generated from field: uint64 ingress_bytes = 11;
   */
  ingressBytes: bigint;

  /**
   * The number of egress bytes sent for the operation, which may include
   * the response or other data not provided by a model.
   *
   * @generated from field: uint64 egress_bytes = 12;
   */
  egressBytes: bigint;

  /**
   * Data associated with the message.
   *
   * @generated from oneof chat.v3.Message.data
   */
  data: {
    /**
     * @generated from field: chat.v3.MessagePingData message_ping_data = 13;
     */
    value: MessagePingData;
    case: "messagePingData";
  } | {
    /**
     * @generated from field: chat.v3.MessageErrorData message_error_data = 14;
     */
    value: MessageErrorData;
    case: "messageErrorData";
  } | {
    /**
     * @generated from field: chat.v3.MessageWarningData message_warning_data = 15;
     */
    value: MessageWarningData;
    case: "messageWarningData";
  } | {
    /**
     * @generated from field: chat.v3.MessageLimitData message_limit_data = 16;
     */
    value: MessageLimitData;
    case: "messageLimitData";
  } | {
    /**
     * @generated from field: chat.v3.MessageStartData message_start_data = 17;
     */
    value: MessageStartData;
    case: "messageStartData";
  } | {
    /**
     * @generated from field: chat.v3.MessageDeltaData message_delta_data = 18;
     */
    value: MessageDeltaData;
    case: "messageDeltaData";
  } | {
    /**
     * @generated from field: chat.v3.MessageDeltaHeartbeatData message_delta_heartbeat_data = 19;
     */
    value: MessageDeltaHeartbeatData;
    case: "messageDeltaHeartbeatData";
  } | {
    /**
     * @generated from field: chat.v3.MessageData message_data = 20;
     */
    value: MessageData;
    case: "messageData";
  } | {
    /**
     * @generated from field: chat.v3.MessageStopData message_stop_data = 21;
     */
    value: MessageStopData;
    case: "messageStopData";
  } | {
    /**
     * @generated from field: chat.v3.MessageTaskData message_task_data = 22;
     */
    value: MessageTaskData;
    case: "messageTaskData";
  } | {
    /**
     * @generated from field: chat.v3.MessageOperationStatusData message_operation_status_data = 23;
     */
    value: MessageOperationStatusData;
    case: "messageOperationStatusData";
  } | {
    /**
     * @generated from field: chat.v3.MessageInsightData message_insight_data = 24;
     */
    value: MessageInsightData;
    case: "messageInsightData";
  } | { case: undefined; value?: undefined };

  /**
   * The number of credits consumed for the tokens in this message.
   *
   * @generated from field: float egress_credits = 25;
   */
  egressCredits: number;

  /**
   * @generated from field: float ingress_credits = 26;
   */
  ingressCredits: number;

  /**
   * @generated from field: float credits_total = 27;
   */
  creditsTotal: number;
};

/**
 * Describes the message chat.v3.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 0);

/**
 * MessageStartData represents the data associated with the start of a message.
 *
 * @generated from message chat.v3.MessageStartData
 */
export type MessageStartData = Message$1<"chat.v3.MessageStartData"> & {
  /**
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The role of the message sender
   *
   * @generated from field: chat.v3.Role role = 2;
   */
  role: Role;

  /**
   * Message type indicates the type of message being started.
   *
   * @generated from field: chat.v3.MessageType message_type = 3;
   */
  messageType: MessageType;

  /**
   * Feature processing the message. Typically a model or tool call.
   *
   * @generated from field: entitlements.v3.Feature feature = 4;
   */
  feature: Feature;

  /**
   * An optional title for the message (or block).
   *
   * @generated from field: optional string title = 5;
   */
  title?: string;

  /**
   * The prompt text we are processing
   *
   * @generated from field: string prompt_text = 6;
   */
  promptText: string;

  /**
   * An initial icon representing the message
   *
   * @generated from field: common.v3.Icon icon = 7;
   */
  icon: Icon;

  /**
   * @generated from field: uint64 ingress_tokens = 8;
   */
  ingressTokens: bigint;

  /**
   * @generated from field: uint64 ingress_bytes = 9;
   */
  ingressBytes: bigint;

  /**
   * @generated from field: float ingress_credits = 10;
   */
  ingressCredits: number;
};

/**
 * Describes the message chat.v3.MessageStartData.
 * Use `create(MessageStartDataSchema)` to create a new message.
 */
export const MessageStartDataSchema: GenMessage<MessageStartData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 1);

/**
 * MessageDeltaData represents the data associated with a delta message.
 * which is a partial update to a text message.
 *
 * @generated from message chat.v3.MessageDeltaData
 */
export type MessageDeltaData = Message$1<"chat.v3.MessageDeltaData"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message chat.v3.MessageDeltaData.
 * Use `create(MessageDeltaDataSchema)` to create a new message.
 */
export const MessageDeltaDataSchema: GenMessage<MessageDeltaData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 2);

/**
 * MessageDeltaHeartbeatData represents the data associated with a temporary
 * delta message. This is used to provide a temporary update that can be
 * removed by a client when a stop delta message is received.
 *
 * For example, a tool that does not the ability so stream tokens may send
 * progress updates on a timer using this message type. The client may then
 * remove them when the final message is received and we have
 * user-facing content.
 *
 * @generated from message chat.v3.MessageDeltaHeartbeatData
 */
export type MessageDeltaHeartbeatData = Message$1<"chat.v3.MessageDeltaHeartbeatData"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message chat.v3.MessageDeltaHeartbeatData.
 * Use `create(MessageDeltaHeartbeatDataSchema)` to create a new message.
 */
export const MessageDeltaHeartbeatDataSchema: GenMessage<MessageDeltaHeartbeatData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 3);

/**
 * MessageData represents the data associated with completed message.
 *
 * @generated from message chat.v3.MessageData
 */
export type MessageData = Message$1<"chat.v3.MessageData"> & {
  /**
   * @generated from oneof chat.v3.MessageData.content
   */
  content: {
    /**
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: chat.v3.RichText rich_text = 2;
     */
    value: RichText;
    case: "richText";
  } | { case: undefined; value?: undefined };

  /**
   * Allow messages to share LLM telemetry data
   *
   * @generated from field: repeated chat.v3.FeatureMetricsSet metrics = 100;
   */
  metrics: FeatureMetricsSet[];

  /**
   * Allow messages to share structured data on search results
   *
   * @generated from field: optional chat.v3.SearchResult search_results = 101;
   */
  searchResults?: SearchResult;

  /**
   * Allow billing data to be attached to messages
   *
   * @generated from field: optional chat.v3.CreditStatement credit_statement = 102;
   */
  creditStatement?: CreditStatement;
};

/**
 * Describes the message chat.v3.MessageData.
 * Use `create(MessageDataSchema)` to create a new message.
 */
export const MessageDataSchema: GenMessage<MessageData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 4);

/**
 * MessageStopData represents the data associated with a message stop event.
 * This includes accounting information for ingress and egress bytes and tokens
 * by feature when the message processing is complete.
 *
 * @generated from message chat.v3.MessageStopData
 */
export type MessageStopData = Message$1<"chat.v3.MessageStopData"> & {
  /**
   * Metrics grouped by feature (model, tool, etc.)
   *
   * @generated from field: map<string, chat.v3.FeatureMetrics> feature_metrics = 1;
   */
  featureMetrics: { [key: string]: FeatureMetrics };
};

/**
 * Describes the message chat.v3.MessageStopData.
 * Use `create(MessageStopDataSchema)` to create a new message.
 */
export const MessageStopDataSchema: GenMessage<MessageStopData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 5);

/**
 * @generated from message chat.v3.CreditStatement
 */
export type CreditStatement = Message$1<"chat.v3.CreditStatement"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;

  /**
   * @generated from field: repeated chat.v3.Debit debits = 2;
   */
  debits: Debit[];
};

/**
 * Describes the message chat.v3.CreditStatement.
 * Use `create(CreditStatementSchema)` to create a new message.
 */
export const CreditStatementSchema: GenMessage<CreditStatement> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 6);

/**
 * @generated from message chat.v3.Debit
 */
export type Debit = Message$1<"chat.v3.Debit"> & {
  /**
   * @generated from field: string activity = 1;
   */
  activity: string;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId: string;

  /**
   * @generated from field: chat.v3.FeatureMetricsSet metrics = 3;
   */
  metrics?: FeatureMetricsSet;
};

/**
 * Describes the message chat.v3.Debit.
 * Use `create(DebitSchema)` to create a new message.
 */
export const DebitSchema: GenMessage<Debit> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 7);

/**
 * @generated from message chat.v3.FeatureMetricsSet
 */
export type FeatureMetricsSet = Message$1<"chat.v3.FeatureMetricsSet"> & {
  /**
   * @generated from field: entitlements.v3.Feature feature = 1;
   */
  feature: Feature;

  /**
   * @generated from field: chat.v3.FeatureMetrics metrics = 2;
   */
  metrics?: FeatureMetrics;

  /**
   * @generated from field: chat.v3.FeatureTokens feature_tokens = 3;
   */
  featureTokens?: FeatureTokens;
};

/**
 * Describes the message chat.v3.FeatureMetricsSet.
 * Use `create(FeatureMetricsSetSchema)` to create a new message.
 */
export const FeatureMetricsSetSchema: GenMessage<FeatureMetricsSet> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 8);

/**
 * @generated from message chat.v3.FeatureTokens
 */
export type FeatureTokens = Message$1<"chat.v3.FeatureTokens"> & {
  /**
   * @generated from field: chat.v3.FeatureTokenType type = 1;
   */
  type: FeatureTokenType;

  /**
   * @generated from field: float ingress_credits = 2;
   */
  ingressCredits: number;

  /**
   * @generated from field: float egress_credits = 3;
   */
  egressCredits: number;

  /**
   * @generated from field: float total_credits = 4;
   */
  totalCredits: number;
};

/**
 * Describes the message chat.v3.FeatureTokens.
 * Use `create(FeatureTokensSchema)` to create a new message.
 */
export const FeatureTokensSchema: GenMessage<FeatureTokens> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 9);

/**
 * @generated from message chat.v3.SearchResult
 */
export type SearchResult = Message$1<"chat.v3.SearchResult"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: google.protobuf.Duration duration = 5;
   */
  duration?: Duration;

  /**
   * @generated from oneof chat.v3.SearchResult.results
   */
  results: {
    /**
     * @generated from field: chat.v3.AssetSearchResults assets = 2;
     */
    value: AssetSearchResults;
    case: "assets";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chat.v3.SearchResult.
 * Use `create(SearchResultSchema)` to create a new message.
 */
export const SearchResultSchema: GenMessage<SearchResult> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 10);

/**
 * @generated from message chat.v3.AssetSearchResults
 */
export type AssetSearchResults = Message$1<"chat.v3.AssetSearchResults"> & {
  /**
   * @generated from field: repeated chat.v3.AssetSummary assets = 1;
   */
  assets: AssetSummary[];
};

/**
 * Describes the message chat.v3.AssetSearchResults.
 * Use `create(AssetSearchResultsSchema)` to create a new message.
 */
export const AssetSearchResultsSchema: GenMessage<AssetSearchResults> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 11);

/**
 * @generated from message chat.v3.AssetSummary
 */
export type AssetSummary = Message$1<"chat.v3.AssetSummary"> & {
  /**
   * The unique identifier for the asset
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The human-readable name of the asset
   *
   * @generated from field: string original_filename = 2;
   */
  originalFilename: string;

  /**
   * System generated name
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * The type of asset (e.g., "image", "audio", "document")
   *
   * @generated from field: string type = 4;
   */
  type: string;

  /**
   * The size of the asset in bytes
   *
   * @generated from field: uint64 size_bytes = 5;
   */
  sizeBytes: bigint;

  /**
   * The URL where the asset can be accessed
   *
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * Summary of the asset
   *
   * @generated from field: string summary = 7;
   */
  summary: string;
};

/**
 * Describes the message chat.v3.AssetSummary.
 * Use `create(AssetSummarySchema)` to create a new message.
 */
export const AssetSummarySchema: GenMessage<AssetSummary> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 12);

/**
 * FeatureMetrics contains the accounting data for a specific feature
 *
 * @generated from message chat.v3.FeatureMetrics
 */
export type FeatureMetrics = Message$1<"chat.v3.FeatureMetrics"> & {
  /**
   * The number of tokens received from the feature
   *
   * @generated from field: uint64 ingress_tokens = 1;
   */
  ingressTokens: bigint;

  /**
   * The number of tokens sent to the feature
   *
   * @generated from field: uint64 egress_tokens = 2;
   */
  egressTokens: bigint;

  /**
   * The number of ingress bytes received for the operation
   *
   * @generated from field: uint64 ingress_bytes = 3;
   */
  ingressBytes: bigint;

  /**
   * The number of egress bytes sent for the operation
   *
   * @generated from field: uint64 egress_bytes = 4;
   */
  egressBytes: bigint;
};

/**
 * Describes the message chat.v3.FeatureMetrics.
 * Use `create(FeatureMetricsSchema)` to create a new message.
 */
export const FeatureMetricsSchema: GenMessage<FeatureMetrics> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 13);

/**
 * MessageTaskData represents the data associated with task operations
 *
 * @generated from message chat.v3.MessageTaskData
 */
export type MessageTaskData = Message$1<"chat.v3.MessageTaskData"> & {
  /**
   * Unique identifier for the task
   * Format: ^task_[a-z0-9]{20}$
   *
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * Human-readable task name/title
   *
   * @generated from field: string task_name = 2;
   */
  taskName: string;

  /**
   * Current status of the task
   *
   * @generated from field: chat.v3.TaskStatus status = 3;
   */
  status: TaskStatus;

  /**
   * Progress percentage (0-100)
   *
   * @generated from field: int32 progress_percent = 4;
   */
  progressPercent: number;

  /**
   * Optional description of current activity
   *
   * @generated from field: optional string current_activity = 5;
   */
  currentActivity?: string;

  /**
   * Dependencies - other task IDs this task depends on
   *
   * @generated from field: repeated string dependencies = 6;
   */
  dependencies: string[];

  /**
   * Task metadata (tool calls, parameters, etc.)
   *
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata: { [key: string]: string };

  /**
   * Error information if task failed
   *
   * @generated from field: optional string error_message = 8;
   */
  errorMessage?: string;

  /**
   * Duration estimates from activity schemas
   *
   * @generated from field: optional chat.v3.TaskDurationInfo duration_info = 9;
   */
  durationInfo?: TaskDurationInfo;

  /**
   * Icon representing the task type or status
   *
   * @generated from field: optional common.v3.Icon icon = 10;
   */
  icon?: Icon;
};

/**
 * Describes the message chat.v3.MessageTaskData.
 * Use `create(MessageTaskDataSchema)` to create a new message.
 */
export const MessageTaskDataSchema: GenMessage<MessageTaskData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 14);

/**
 * TaskDurationInfo provides comprehensive timing information for tasks
 *
 * @generated from message chat.v3.TaskDurationInfo
 */
export type TaskDurationInfo = Message$1<"chat.v3.TaskDurationInfo"> & {
  /**
   * Expected duration in milliseconds (from schema)
   *
   * @generated from field: uint64 expected_duration_ms = 1;
   */
  expectedDurationMs: bigint;

  /**
   * Minimum expected duration in milliseconds (from schema)
   *
   * @generated from field: optional uint64 min_duration_ms = 2;
   */
  minDurationMs?: bigint;

  /**
   * Maximum expected duration in milliseconds (from schema)
   *
   * @generated from field: optional uint64 max_duration_ms = 3;
   */
  maxDurationMs?: bigint;

  /**
   * Task category (e.g., "search", "analysis", "generation")
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * Confidence level ("high", "medium", "low")
   *
   * @generated from field: string confidence = 5;
   */
  confidence: string;

  /**
   * Whether the task runs synchronously or asynchronously
   *
   * @generated from field: bool is_synchronous = 6;
   */
  isSynchronous: boolean;

  /**
   * Human-readable description of what the task does
   *
   * @generated from field: string description = 7;
   */
  description: string;
};

/**
 * Describes the message chat.v3.TaskDurationInfo.
 * Use `create(TaskDurationInfoSchema)` to create a new message.
 */
export const TaskDurationInfoSchema: GenMessage<TaskDurationInfo> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 15);

/**
 * MessageOperationStatusData represents operational status for any activity
 *
 * @generated from message chat.v3.MessageOperationStatusData
 */
export type MessageOperationStatusData = Message$1<"chat.v3.MessageOperationStatusData"> & {
  /**
   * Unique identifier for the operation
   * Format: ^operation_[a-z0-9]{20}$
   *
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * System activity key
   *
   * @generated from field: string activity = 2;
   */
  activity: string;

  /**
   * Human-readable name of the operation
   *
   * @generated from field: string operation_name = 3;
   */
  operationName: string;

  /**
   * Current status of the operation
   *
   * @generated from field: chat.v3.OperationStatus status = 4;
   */
  status: OperationStatus;

  /**
   * Current activity description (e.g., "Analyzing user intent...", "Searching knowledge base...")
   *
   * @generated from field: optional string progress_message = 6;
   */
  progressMessage?: string;

  /**
   * Timing information
   *
   * @generated from field: google.protobuf.Timestamp started_at = 7;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 8;
   */
  completedAt?: Timestamp;
};

/**
 * Describes the message chat.v3.MessageOperationStatusData.
 * Use `create(MessageOperationStatusDataSchema)` to create a new message.
 */
export const MessageOperationStatusDataSchema: GenMessage<MessageOperationStatusData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 16);

/**
 * MessageInsightData represents the data associated with an insight event.
 *
 * @generated from message chat.v3.MessageInsightData
 */
export type MessageInsightData = Message$1<"chat.v3.MessageInsightData"> & {
  /**
   * Unique identifier for the insight
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Human-readable label for the insight
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Arbitrary key-value data for the insight
   *
   * @generated from field: map<string, string> values = 3;
   */
  values: { [key: string]: string };
};

/**
 * Describes the message chat.v3.MessageInsightData.
 * Use `create(MessageInsightDataSchema)` to create a new message.
 */
export const MessageInsightDataSchema: GenMessage<MessageInsightData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 17);

/**
 * @generated from enum chat.v3.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Indicates a user generated the message. Users may be human or agents.
   *
   * @generated from enum value: ROLE_USER = 1;
   */
  USER = 1,

  /**
   * Indicates a system generated the message which may be an error, warning,
   * or other information message. System messages are not user generated
   * and are not AI responses.
   *
   * @generated from enum value: ROLE_SYSTEM = 2;
   */
  SYSTEM = 2,

  /**
   * Indicates an AI response.
   *
   * @generated from enum value: ROLE_ASSISTANT = 4;
   */
  ASSISTANT = 4,

  /**
   * Indicates a specialized agent has responded to this message.
   *
   * @generated from enum value: ROLE_AGENT = 11;
   */
  AGENT = 11,

  /**
   * Indicates this message is from a tools or service that was called to
   * perform an action or generate content.
   *
   * @generated from enum value: ROLE_TOOL = 12;
   */
  TOOL = 12,

  /**
   * Indicates this message was the result of a function call or responses.
   *
   * @generated from enum value: ROLE_FUNCTION = 13;
   */
  FUNCTION = 13,
}

/**
 * Describes the enum chat.v3.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 0);

/**
 * @generated from enum chat.v3.Event
 */
export enum Event {
  /**
   * EVENT_UNSPECIFIED represents the default value when no event
   * type is specified. Should not be used.
   *
   * @generated from enum value: EVENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * EVENT_MESSAGE_PING is a heartbeat event to maintain an active connection
   * when streaming messages. This is used to keep the connection alive and is
   * not a message users need to be made aware of. A ping is sent when no other
   * message is streamed for a period of time. Pings are not recorded in a
   * conversation history and will not be present when a streamed conversation
   * is loaded such as when refreshing the browser or revisiting a conversation
   * from yesterday.
   *
   * @generated from enum value: EVENT_MESSAGE_PING = 1;
   */
  MESSAGE_PING = 1,

  /**
   * EVENT_MESSAGE_ERROR indicates an error occurred during message processing
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_ERROR = 2;
   */
  MESSAGE_ERROR = 2,

  /**
   * EVENT_MESSAGE_WARNING indicates a non-fatal issue or warning condition.
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_WARNING = 3;
   */
  MESSAGE_WARNING = 3,

  /**
   * EVENT_MESSAGE_LIMIT provides an update on rate limits or quotas which
   * may be something like "14% used" or "resource has been exhausted".
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_LIMIT = 4;
   */
  MESSAGE_LIMIT = 4,

  /**
   * EVENT_MESSAGE_CANCEL indicates the message processing was canceled.
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_CANCEL = 5;
   */
  MESSAGE_CANCEL = 5,

  /**
   * EVENT_MESSAGE_RETRY indicates a retry of a operation.
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_RETRY = 6;
   */
  MESSAGE_RETRY = 6,

  /**
   * EVENT_PROMPT indicates a prompt that was sent for processing.
   * This type is returned when accessing a conversation that has been
   * previously streamed such as when reloading the browser or revisiting a
   * conversation from yesterday.
   *
   * @generated from enum value: EVENT_PROMPT = 100;
   */
  PROMPT = 100,

  /**
   * EVENT_ACTION_TAKEN indicates an action that was taken. This could be
   * by the user in response to a suggested action or an action taken by
   * the system in a workflow.
   *
   * @generated from enum value: EVENT_ACTION_TAKEN = 101;
   */
  ACTION_TAKEN = 101,

  /**
   * EVENT_MESSAGE indicates an entire message.
   * This type is returned when accessing a conversation that has been
   * previously streamed such as when reloading the browser or revisiting a
   * conversation from yesterday.
   *
   * @generated from enum value: EVENT_MESSAGE = 102;
   */
  MESSAGE = 102,

  /**
   * EVENT_BLOCK indicates an entire block. A message may contain zero
   * or more blocks. All blocks are contained within a message.
   * This type is returned when accessing a conversation that has been
   * previously streamed such as when reloading the browser or revisiting a
   * conversation from yesterday.
   *
   * @generated from enum value: EVENT_BLOCK = 103;
   */
  BLOCK = 103,

  /**
   * EVENT_MESSAGE_START indicates the beginning of a new streaming message.
   * Additional events will follow such as EVENT_MESSAGE_DELTA and EVENT_MESSAGE_STOP.
   * Additionally, additional EVENT_MESSAGE_BLOCK_* events may be sent
   * before EVENT_MESSAGE_STOP.
   *
   * @generated from enum value: EVENT_MESSAGE_START = 1000;
   */
  MESSAGE_START = 1000,

  /**
   * EVENT_MESSAGE_DELTA provides an incremental content update for a
   * streaming message. Deltas will always be plain-text/markdown.
   * to a message.
   *
   * @generated from enum value: EVENT_MESSAGE_DELTA = 1001;
   */
  MESSAGE_DELTA = 1001,

  /**
   * EVENT_MESSAGE_STOP indicates the message generation is complete for steamed
   * messages. This is the last event sent and indicates
   * that the turn is over.
   *
   * When processing a rich text message, the entire message for the
   * index will be sent as rich text. This allows a rich text client to
   * incrementally show progress to a user before swapping the entire message
   * for a rich text document complete with encoded meta data.
   *
   * @generated from enum value: EVENT_MESSAGE_STOP = 1002;
   */
  MESSAGE_STOP = 1002,

  /**
   * EVENT_MESSAGE_BLOCK_START indicates the beginning of a content block
   * for a streaming message. A block is a sub-part of a message and may be
   * used to provide additional context, used for formatting, or relay other
   * information. All blocks are contained within messages.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_START = 1003;
   */
  MESSAGE_BLOCK_START = 1003,

  /**
   * EVENT_MESSAGE_BLOCK_DELTA provides an incremental update for the
   * current block in a streaming message. Incremental updates will always
   * be plain-text/markdown.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_DELTA = 1004;
   */
  MESSAGE_BLOCK_DELTA = 1004,

  /**
   * EVENT_MESSAGE_BLOCK_STOP indicates the block generation is complete
   * for a streamed message.
   *
   * When processing a rich text message, the entire block will be sent as
   * rich text. This allows a rich text client to incrementally show
   * progress to a user before swapping the entire block for a rich text
   * representation complete with encoded meta data.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_STOP = 1005;
   */
  MESSAGE_BLOCK_STOP = 1005,

  /**
   * EVENT_MESSAGE_BLOCK_GENERATION_START indicates the start of a block
   * that is generating content. This may be for the generation of
   * instructions to be used by a model or tool or for the generation
   * of artifacts such as images, audio, or other content.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_GENERATION_START = 1006;
   */
  MESSAGE_BLOCK_GENERATION_START = 1006,

  /**
   * EVENT_MESSAGE_BLOCK_GENERATION_DELTA provides an incremental update
   * for the current block that is generating content.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_GENERATION_DELTA = 1007;
   */
  MESSAGE_BLOCK_GENERATION_DELTA = 1007,

  /**
   * EVENT_MESSAGE_BLOCK_GENERATION_STOP indicates the block generation
   * is complete for a streamed message.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_GENERATION_STOP = 1008;
   */
  MESSAGE_BLOCK_GENERATION_STOP = 1008,

  /**
   * EVENT_OPERATION_START indicates the beginning of an operation
   *
   * @generated from enum value: EVENT_OPERATION_START = 10000;
   */
  OPERATION_START = 10000,

  /**
   * EVENT_OPERATION_PROGRESS provides incremental updates during operation execution
   *
   * @generated from enum value: EVENT_OPERATION_PROGRESS = 10001;
   */
  OPERATION_PROGRESS = 10001,

  /**
   * EVENT_OPERATION_COMPLETE indicates successful operation completion
   *
   * @generated from enum value: EVENT_OPERATION_COMPLETE = 10002;
   */
  OPERATION_COMPLETE = 10002,

  /**
   * EVENT_OPERATION_FAILED indicates operation failed with error details
   *
   * @generated from enum value: EVENT_OPERATION_FAILED = 10003;
   */
  OPERATION_FAILED = 10003,

  /**
   * EVENT_OPERATION_CANCELLED indicates operation was cancelled before completion
   *
   * @generated from enum value: EVENT_OPERATION_CANCELLED = 10004;
   */
  OPERATION_CANCELLED = 10004,

  /**
   * EVENT_INSIGHT is used to send discovered insights, detected concepts, etc.
   * This event is only sent by itself, not as part of a start/delta/stop sequence.
   *
   * @generated from enum value: EVENT_INSIGHT = 11000;
   */
  INSIGHT = 11000,
}

/**
 * Describes the enum chat.v3.Event.
 */
export const EventSchema: GenEnum<Event> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 1);

/**
 * @generated from enum chat.v3.MessageType
 */
export enum MessageType {
  /**
   * @generated from enum value: MESSAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * MESSAGE_TYPE_PROMPT_ACK is typically the first message sent when
   * processing begins and is an acknowledgment that the prompt has been
   * received and processing has started.
   *
   * @generated from enum value: MESSAGE_TYPE_PROMPT_ACK = 1;
   */
  PROMPT_ACK = 1,

  /**
   * MESSAGE_TYPE_INTERSTITIAL indicates a message that is in-between
   * other more important messages. This is often used to provide feedback to
   * the user that the system is processing and what steps are being taken.
   *
   * Interstitial messages recorded; however, under normal circumstances they
   * are not returned when a conversation is reloaded such as when visiting
   * a conversation from yesterday or reloading your browser. When diagnostic
   * tools are enabled these messages will be returned with history.
   * Examples:
   * - Processing your query...
   * - Searching weather database for San Francisco.
   *
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL = 2;
   */
  INTERSTITIAL = 2,

  /**
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL_DATA = 3;
   */
  INTERSTITIAL_DATA = 3,

  /**
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL_USER_FACING = 4;
   */
  INTERSTITIAL_USER_FACING = 4,

  /**
   * MESSAGE_TYPE_INTERSTITIAL_CATCH is used to transmit data from a model
   * if it responds outside of the expected format.
   *
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL_CATCH = 6;
   */
  INTERSTITIAL_CATCH = 6,

  /**
   * MESSAGE_TYPE_SCOPED provides feedback as to the scope of knowledge that
   * may be used to process the prompt. This is the net that has been cast to
   * find the information needed to answer the prompt. Said differently, the
   * boundary of the knowledge that is being used to answer the prompt.
   *
   * @generated from enum value: MESSAGE_TYPE_SCOPED = 100;
   */
  SCOPED = 100,

  /**
   * MESSAGE_TYPE_REFERENCED indicates what knowledge from scope was actually
   * used provided to a model. For example, if all knowledge labeled with
   * "#foo" was within scope and six pieces of knowledge were referenced
   * out of a pool of 100 pieces of knowledge, this message would indicate
   * the six pieces of knowledge that were actually made available as
   * references.
   *
   * @generated from enum value: MESSAGE_TYPE_REFERENCED = 200;
   */
  REFERENCED = 200,

  /**
   * MESSAGE_TYPE_RATE_FEEDBACK acknowledges feedback or a rating from a user
   * regarding the quality or relevance of a message. This feedback may
   * be used to improve the system's performance or to adjust the
   * response generation process. It is not used for training third-party
   * models.
   *
   * @generated from enum value: MESSAGE_TYPE_RATE_FEEDBACK = 300;
   */
  RATE_FEEDBACK = 300,

  /**
   * MESSAGE_TYPE_SYSTEM_STATUS provides information about the system's
   * current state, performance, or any issues that may be affecting
   * its operation. This message type is used to communicate
   * operational status updates, maintenance notifications,
   * or other relevant system information to users.
   *
   * System status messages recorded; however, under normal circumstances they
   * are not returned when a conversation is reloaded such as when visiting
   * a conversation from yesterday or reloading your browser. When diagnostic
   * tools are enabled these messages will be returned with history.
   *
   * @generated from enum value: MESSAGE_TYPE_SYSTEM_STATUS = 400;
   */
  SYSTEM_STATUS = 400,

  /**
   * MESSAGE_TYPE_MEMORY_UPDATE indicates a detail from a prompt was
   * added to memory. This is used to personalize the experience for the user
   * and may be used to provide a more relevant response in the future.
   *
   * @generated from enum value: MESSAGE_TYPE_MEMORY_UPDATE = 500;
   */
  MEMORY_UPDATE = 500,

  /**
   * MESSAGE_TYPE_TASK_CREATE indicates a task has been created.
   *
   * @generated from enum value: MESSAGE_TYPE_TASK_CREATE = 600;
   */
  TASK_CREATE = 600,

  /**
   * MESSAGE_TYPE_TASK_UPDATE indicates a task has been updated.
   *
   * @generated from enum value: MESSAGE_TYPE_TASK_UPDATE = 601;
   */
  TASK_UPDATE = 601,

  /**
   * MESSAGE_TYPE_OPERATION_STATUS provides operation lifecycle information
   * for activities like triage, intent analysis, strategy planning, and web search.
   * These messages track the complete lifecycle of operations independent of blocks.
   *
   * @generated from enum value: MESSAGE_TYPE_OPERATION_STATUS = 700;
   */
  OPERATION_STATUS = 700,

  /**
   * MESSAGE_TYPE_CONTENT is the primary content message type.
   *
   * Example: "The average temperature in San Francisco is 57°F (14°C) annually,
   * with September typically being the warmest month."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT = 1000;
   */
  CONTENT = 1000,

  /**
   * MESSAGE_TYPE_CONTENT_EXPLANATION indicates explanatory content that
   * supports answers or responses by providing reasoning, limitations,
   * additional considerations, or methodological details.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "This temperature data is based on 30-year averages from NOAA
   * and may not reflect recent climate trends. Microclimates within the city
   * can vary by 5-10°F."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_EXPLANATION = 1001;
   */
  CONTENT_EXPLANATION = 1001,

  /**
   * MESSAGE_TYPE_CONTENT_CITATION provides attribution information for sources,
   * references, or evidence that supports the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "Data source: National Oceanic and Atmospheric Administration,
   * Climate.gov, 'San Francisco Climate Data 1991-2020', accessed April 2025."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_CITATION = 1002;
   */
  CONTENT_CITATION = 1002,

  /**
   * MESSAGE_TYPE_CONTENT_SUMMARY provides a condensed version of longer content,
   * highlighting key points or conclusions.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "San Francisco enjoys mild temperatures year-round with
   * minimal seasonal variation compared to other U.S. cities."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_SUMMARY = 1003;
   */
  CONTENT_SUMMARY = 1003,

  /**
   * MESSAGE_TYPE_CONTENT_DISCLAIMER contains important caveats, limitations, or
   * legal notices that users should be aware of regarding the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "This information is provided for general reference only and
   * should not be used for critical weather-dependent planning without
   * consulting local forecasts."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_DISCLAIMER = 1004;
   */
  CONTENT_DISCLAIMER = 1004,

  /**
   * MESSAGE_TYPE_CONTENT_ALTERNATIVE presents different options, approaches, or
   * interpretations to the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "Alternative measurement: Using the heat index that accounts for
   * humidity, San Francisco's 'feels like' temperature is often lower than
   * the actual reading."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_ALTERNATIVE = 1005;
   */
  CONTENT_ALTERNATIVE = 1005,

  /**
   * MESSAGE_TYPE_CONTENT_ELABORATION provides additional details, examples, or
   * extended information that builds upon the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "The city's famous fog, locally nicknamed 'Karl', contributes
   * significantly to temperature regulation, especially during summer months
   * when inland areas experience much higher temperatures."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_ELABORATION = 1006;
   */
  CONTENT_ELABORATION = 1006,

  /**
   * MESSAGE_TYPE_CONTENT_PREREQUISITE contains background information or concepts
   * necessary to understand the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "Temperature in meteorology is measured using either
   * Fahrenheit (°F) or Celsius (°C) scales, with the latter being standard
   * in scientific contexts and most countries outside the United States."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_PREREQUISITE = 1007;
   */
  CONTENT_PREREQUISITE = 1007,

  /**
   * MESSAGE_TYPE_CONTENT_CLARIFICATION addresses potential misunderstandings or
   * ambiguities in the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "To clarify, when we reference 'San Francisco temperatures',
   * we're measuring at the official weather station located near downtown,
   * not at coastal areas which can be significantly cooler."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_CLARIFICATION = 1008;
   */
  CONTENT_CLARIFICATION = 1008,

  /**
   * MESSAGE_TYPE_CONTENT_NEXT_STEPS suggests actions, further reading, or follow-up
   * items related to the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "For more detailed climate information, check the SF Microclimate
   * Map or subscribe to neighborhood-specific weather alerts through the city's
   * notification system."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_NEXT_STEPS = 1009;
   */
  CONTENT_NEXT_STEPS = 1009,

  /**
   * MESSAGE_TYPE_CONTENT_ERROR_CORRECTION identifies and fixes mistakes in
   * previously delivered content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "Correction: In our previous message, we stated that October was
   * the warmest month in San Francisco. The warmest month is actually
   * September, with an average high of 71°F (22°C)."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_ERROR_CORRECTION = 1010;
   */
  CONTENT_ERROR_CORRECTION = 1010,

  /**
   * MESSAGE_TYPE_CONTENT_WALKTHROUGH provides step-by-step guidance related to
   * the primary content, often used for tutorials or instructions.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "To convert Fahrenheit to Celsius: 1) Subtract 32 from the
   * temperature, 2) Multiply by 5, 3) Divide by 9. For example, 57°F:
   * (57-32)×5÷9 = 14°C."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_WALKTHROUGH = 1011;
   */
  CONTENT_WALKTHROUGH = 1011,

  /**
   * MESSAGE_TYPE_CONTENT_TECHNICAL_DETAILS contains specialized information
   * like specifications, parameters, or implementation details supporting the
   * main content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "Temperature sensors used in San Francisco's weather stations are
   * RTD PT100 models with ±0.1°C accuracy, calibrated quarterly, and placed 2
   * meters above ground level in ventilated enclosures."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_TECHNICAL_DETAILS = 1012;
   */
  CONTENT_TECHNICAL_DETAILS = 1012,

  /**
   * MESSAGE_TYPE_CONTENT_HISTORICAL_CONTEXT provides temporal background or evolution
   * of concepts mentioned in the primary content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "San Francisco's temperature records date back to 1849, showing
   * that average temperatures have increased by approximately 1.7°F over the
   * past century, with most of that change occurring after 1980."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_HISTORICAL_CONTEXT = 1013;
   */
  CONTENT_HISTORICAL_CONTEXT = 1013,

  /**
   * MESSAGE_TYPE_CONTENT_COMPARISON contrasts different elements, approaches, or
   * solutions related to the primary content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "While San Francisco averages 57°F annually, nearby cities show
   * significant differences: Oakland averages 63°F, Pacifica 55°F, and San Jose
   * 70°F, demonstrating the Bay Area's dramatic microclimate variations."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_COMPARISON = 1014;
   */
  CONTENT_COMPARISON = 1014,

  /**
   * MESSAGE_TYPE_CONTENT_EXAMPLE illustrates concepts from the primary content
   * with concrete instances or sample implementations.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "As an example of San Francisco's temperature consistency, on July 12, 2024,
   * downtown recorded a high of 65°F while Phoenix reached 112°F and Chicago 91°F on the
   * same day."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_EXAMPLE = 1015;
   */
  CONTENT_EXAMPLE = 1015,

  /**
   * MESSAGE_TYPE_DATA_VISUALIZATION indicates a message that is used to
   * visualize data such as drawing a chart or graph.
   *
   * This content won't appear naturally appear within MESSAGE_TYPE_CONTENT.
   * It will be discreetly this content type when generated as part of a
   * prepared plan or by a user when they request for an entire message
   * or a specific section of a message.
   *
   * Example (but rendered as a chart from structured data):
   *
   * "AAPL Stock Price (Last 30 Days)
   *
   *  $215 |                                     *
   *       |                            *      *   *
   *  $210 |                      *   *   *  *
   *       |               *    *  *
   *  $205 |         *   *  *
   *       |       *  *
   *  $200 |    *
   *       |  *
   *  $195 |*
   *       +--------------------------------------
   *        01  05  10  15  20  25  30  APR 2025
   *
   * Trading Volume (millions)
   *    30 |   |  |
   *    20 |   |  |     |  |     |  |  |     |
   *    10 ||| | || ||| | || ||| | || | ||| ||
   *       +--------------------------------------"
   *
   * @generated from enum value: MESSAGE_TYPE_DATA_VISUALIZATION = 1016;
   */
  DATA_VISUALIZATION = 1016,

  /**
   * MESSAGE_TYPE_SUGGESTED_ACTION indicates a message that is used to
   * suggest an action to the user.
   *
   * This content won't appear naturally appear within MESSAGE_TYPE_CONTENT.
   * It will be discreetly this content type when generated as part of a
   * prepared plan or by a user when they request for an entire message
   * or a specific section of a message.
   *
   * Example: "Do you want to [ SAVE ] or [ SHARE ] this message?"
   *
   * @generated from enum value: MESSAGE_TYPE_SUGGESTED_ACTION = 1017;
   */
  SUGGESTED_ACTION = 1017,

  /**
   * MESSAGE_TYPE_CLARIFICATION_REQUEST indicates a message that is used to
   * request clarification from the user.
   *
   * @generated from enum value: MESSAGE_TYPE_CLARIFICATION_REQUEST = 1018;
   */
  CLARIFICATION_REQUEST = 1018,

  /**
   * MESSAGE_TYPE_ARTIFACT_CREATION indicates a message that is used to
   * generate an artifact such as an image, audio, or other content.
   *
   * @generated from enum value: MESSAGE_TYPE_ARTIFACT_CREATION = 1019;
   */
  ARTIFACT_CREATION = 1019,

  /**
   * MESSAGE_TYPE_ARTIFACT_REVISION indicates a message that is used to
   * revise an artifact such as an image, audio, or other content.
   *
   * @generated from enum value: MESSAGE_TYPE_ARTIFACT_REVISION = 1020;
   */
  ARTIFACT_REVISION = 1020,
}

/**
 * Describes the enum chat.v3.MessageType.
 */
export const MessageTypeSchema: GenEnum<MessageType> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 2);

/**
 * OperationStatus represents the current state of an operation
 *
 * @generated from enum chat.v3.OperationStatus
 */
export enum OperationStatus {
  /**
   * @generated from enum value: OPERATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Operation is starting up
   *
   * @generated from enum value: OPERATION_STATUS_STARTING = 1;
   */
  STARTING = 1,

  /**
   * Operation is actively running
   *
   * @generated from enum value: OPERATION_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * Operation completed successfully
   *
   * @generated from enum value: OPERATION_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * Operation failed with an error
   *
   * @generated from enum value: OPERATION_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * Operation was cancelled
   *
   * @generated from enum value: OPERATION_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,

  /**
   * Operation is retrying after a failure
   *
   * @generated from enum value: OPERATION_STATUS_RETRYING = 6;
   */
  RETRYING = 6,
}

/**
 * Describes the enum chat.v3.OperationStatus.
 */
export const OperationStatusSchema: GenEnum<OperationStatus> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 3);

/**
 * ActivityType represents the type of activity being performed
 *
 * @generated from enum chat.v3.ActivityType
 */
export enum ActivityType {
  /**
   * @generated from enum value: ACTIVITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTIVITY_TYPE_TRIAGE = 1;
   */
  TRIAGE = 1,

  /**
   * @generated from enum value: ACTIVITY_TYPE_INTENT_ANALYSIS = 2;
   */
  INTENT_ANALYSIS = 2,

  /**
   * @generated from enum value: ACTIVITY_TYPE_STRATEGY_PLANNING = 3;
   */
  STRATEGY_PLANNING = 3,

  /**
   * @generated from enum value: ACTIVITY_TYPE_WEB_SEARCH = 4;
   */
  WEB_SEARCH = 4,

  /**
   * @generated from enum value: ACTIVITY_TYPE_CONTENT_GENERATION = 5;
   */
  CONTENT_GENERATION = 5,

  /**
   * @generated from enum value: ACTIVITY_TYPE_DOCUMENT_PROCESSING = 6;
   */
  DOCUMENT_PROCESSING = 6,
}

/**
 * Describes the enum chat.v3.ActivityType.
 */
export const ActivityTypeSchema: GenEnum<ActivityType> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 4);

/**
 * @generated from enum chat.v3.FeatureTokenType
 */
export enum FeatureTokenType {
  /**
   * @generated from enum value: FEATURE_TOKEN_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * FEATURE_TOKEN_TYPE_ACCUMULATE indicates tokens should be accumulated by
   * a client.
   *
   * @generated from enum value: FEATURE_TOKEN_TYPE_ACCUMULATE = 1;
   */
  ACCUMULATE = 1,

  /**
   * FEATURE_TOKEN_TYPE_FINAL indicates tokens are final and can replace
   * accumulated tokens.
   *
   * @generated from enum value: FEATURE_TOKEN_TYPE_FINAL = 2;
   */
  FINAL = 2,

  /**
   * FEATURE_TOKEN_TYPE_ACCUMULATED indicates tokens are accumulated by the
   * server and a client need not accumulate them.
   *
   * @generated from enum value: FEATURE_TOKEN_TYPE_ACCUMULATED = 3;
   */
  ACCUMULATED = 3,
}

/**
 * Describes the enum chat.v3.FeatureTokenType.
 */
export const FeatureTokenTypeSchema: GenEnum<FeatureTokenType> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 5);

/**
 * TaskStatus represents the current state of a task
 *
 * @generated from enum chat.v3.TaskStatus
 */
export enum TaskStatus {
  /**
   * @generated from enum value: TASK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Task has been planned but not yet started
   *
   * @generated from enum value: TASK_STATUS_PLANNED = 1;
   */
  PLANNED = 1,

  /**
   * Task is currently being executed
   *
   * @generated from enum value: TASK_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * Task has completed successfully
   *
   * @generated from enum value: TASK_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * Task encountered an error and failed
   *
   * @generated from enum value: TASK_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * Task was cancelled before completion
   *
   * @generated from enum value: TASK_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,

  /**
   * Task is waiting for dependencies to complete
   *
   * @generated from enum value: TASK_STATUS_BLOCKED = 6;
   */
  BLOCKED = 6,
}

/**
 * Describes the enum chat.v3.TaskStatus.
 */
export const TaskStatusSchema: GenEnum<TaskStatus> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 6);

